export const UPDATE_QUOTE_STATUS = "UPDATE_QUOTE_STATUS"